import { getImageNameWithTag } from "@/helpers/string.helpers"

import { Resource } from "."

import styles from "./Resources.module.scss"

import type { SingleImageResourcePopoverProps } from "."

export const SingleImageResourcePopover: React.FC<
  SingleImageResourcePopoverProps
> = (props) => {
  const { onClick } = props
  let data

  if ("resources" in props) data = props.resources
  else {
    const { digest, tag, name, type: _, ...rest } = props
    const type = "ImageRepository" as const

    data = [
      { type, name: getImageNameWithTag(name, tag), tag: digest, ...rest }
    ]
  }

  return (
    <div>
      {data.map(({ tag, name, popoverName, ...resource }, index) => {
        const displayName = popoverName || name

        // Serverless images (Lambda functions, Azure apps whose image has no digest) have
        // no digest: show no "Digest:" line rather than an empty one
        return (
          <Resource
            key={index}
            copyable={{
              ...(tag && { tag: { text: tag, tooltips: false } }),
              name: {
                text: displayName,
                tooltips: false
              }
            }}
            tag={tag ? `Digest: ${tag}` : ""}
            onClick={onClick}
            classes={{ container: styles.contentSingleResourcePopover }}
            name={displayName}
            {...resource}
          />
        )
      })}
    </div>
  )
}
